import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IAddIconProps extends ISvgIconProps {

}

export class AddIcon extends React.Component<IAddIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <polygon points="0 0 24 0 24 24 0 24"></polygon>
                    <path d={
                        // R 12
                        "M12,0 C5.38,0 0,5.38 0,12 C0,18.62 5.38,24 12,24 C18.62,24 24,18.62 24,12 C24,5.38 18.62,0 12,0 Z " +
                        // R 11
                        // "M12,1 C5.92,1 1,5.92 1,12 C1,18.07 5.92,23 12,23 C18.07,23 23,18.07 23,12 C23,5.92 18.07,1 12,1 Z " +
                        // R 10
                        // "M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z " +

                        "M17,13 L13,13 L13,17 L11,17 L11,13 L7,13 L7,11 " +
                        "L11,11 L11,7 L13,7 L13,11 L17,11 L17,13 Z"
                    }
                    fill="currentColor" fillRule="nonzero"></path>
                </g>
            </SvgIcon>
        );
    }
}
